module.exports = __webpack_public_path__ + "static/media/TableCorner_After.7f3cafe5.jpg";